import { Pipe, PipeTransform } from '@angular/core';

/**
 * Takes a number value and if it's negative
 * returns a string in brackets of this value (without minus).
 * Usage:
 *         value| negativeValueToBraces
 * Example:
 *         {{-2 | negativeValueToBraces}}
 *         formats to '(-2)'
 */
@Pipe({
  name: 'negativeValueToBraces',
})
export class NegativeValueToBracesPipe implements PipeTransform {
  transform(value: any): string {
    if (!value || value === '-') {
      return value;
    }
    value = value.toString();
    return value.charAt(0) === '-' ? `(${value.substr(1,value.length)})` : value;
  }

}
